import React, { useEffect, useState, useRef } from "react";
import uuid from "uuid/v1";
import "../assets/scss/_title.scss";
import Input from "./Input";
import TableTextbox from "./TableTextbox";
import { useDispatch, useSelector } from "react-redux";
import { setAllWorkplans } from "~/store/ducks/budgetManagement/actionTypes";
import TableInput from "./TableInput";
import ProposalHoursTable from "./ProposalHoursTable";
import ProposalSuppliersTable from "./ProposalSuppliersTable";
import ProposalCostsTable from "./ProposalCostsTable";
import ProposalResumeSection from "./ProposalResumeSection";
import { useReactToPrint } from "react-to-print";
import SimpleButton from "~/pages/Easypay/components/SimpleButton";

function Simulator({ workplanIndex }) {
  function buildInputField(text, value) {
    return {
      value: value,
      obligatory: false,
      variable: "",
      maxlenght: 100,
      text: text,
    };
  }

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const dispatch = useDispatch();

  const {
    paymentTypes,
    departments,
    factoring,
    collaborators,
    expenses,
    projectTypes,
    providerTypes,
    expenditureTypes,
    workplans,
    triggerLoading,
  } = useSelector((state) => state.budgetManagementReducer);

  function numberWithCommas(x) {
    if (x === "" || x === null || x === undefined) return;
    if (!(x.toString().includes(".") || x.toString().includes(",")))
      return x + ",00";
    const newString = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const newArray = newString.split(".");
    const finalString = newArray[0].replace(",", ".") + "," + newArray[1];
    return finalString;
  }

  const [finalResult, setFinalResult] = useState(0);
  var factureArray = [];
  var factureArrayVerify = [];
  var costArray = [];
  var costArrayVerify = [];

  var costHoursElement = {};
  var hoursElement = {};

  var gpi = 1.0;
  var fse = 1.0;
  var gpd = 1.0;
  var pc = 1.0;
  var pv = 1.0;

  const months = [
    "jan",
    "feb",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "otu",
    "nov",
    "dec",
  ];

  function getNameFromId() {
    const projType = projectTypes.find(
      (x) => x.idTipoProjeto === parseInt(workplans[workplanIndex].tipoProjeto)
    );
    if (projType != null) return projType?.nome;
  }

  function getPositionBottom(index, list) {
    if (index === 0) return "start-end";
    if (index === Object.keys(list).length - 1) return "end";
  }

  const monthsBtwnDates = (startDate, endDate) => {
    if (startDate === null || endDate === null) return;
    var newStart = new Date(startDate);
    var newEnd = new Date(endDate);
    newStart = new Date(
      newStart.getTime() - newStart.getTimezoneOffset() * +60000
    );
    newEnd = new Date(newEnd.getTime() - newEnd.getTimezoneOffset() * +60000);
    var startStr = newStart.toISOString();
    var endStr = newEnd.toISOString();

    startStr = startStr.slice(0, 10);
    endStr = endStr.slice(0, 10);
    var start = startStr.split("-");
    var end = endStr.split("-");
    var startYear = parseInt(start[0]);
    var endYear = parseInt(end[0]);
    var dates = [];

    for (var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : parseInt(end[1]);
      var startMon = i === startYear ? parseInt(start[1]) : 0;

      for (var j = startMon; j <= endMonth; j++) {
        var month = j;
        var displayMonth = month < 10 ? "0" + month : month;
        dates.push([i, displayMonth, "01"].join("-"));
      }
    }

    return dates;
  };

  useEffect(() => {
    if (expenses?.length != 0 && expenses != null && expenses != undefined) {
      const expGPI = expenses.find(
        (x) => x.tipo === "Gastos Pessoal Indireto (GPI)"
      );
      if (expGPI != null) gpi = expGPI.percentagem / 100;

      const expFSE = expenses.find((x) => x.tipo === "FSE");
      if (expFSE != null) fse = expFSE.percentagem / 100;

      const expGPD = expenses.find(
        (x) => x.tipo === "Gastos Pessoal Direto (GPD)"
      );
      if (expGPD != null) gpd = expGPD.percentagem / 100;
    } else {
      fse = 0;
      gpi = 0;
      gpd = 0;
    }

    var factureHoursElement = {};
    var factureSubElement = {};
    var factureCostElement = {};
    var facturFactElement = {};

    var factureHoursVerifyElement = {};
    var factureSubVerifyElement = {};
    var factureCostVerifyElement = {};
    var facturFactVerifyElement = {};

    var titleElement = {};
    var totalFactureElement = {};
    var totalCostElement = {};

    var totalFactureElementVerify = {};
    var totalCostElementVerify = {};

    var costSubElement = {};
    var costCostElement = {};
    var costFactElement = {};

    var costSubVerifyElement = {};
    var costCostVerifyElement = {};
    var costFactVerifyElement = {};

    var incomeElement = {};
    var percentIncomeElement = {};

    var marginElement = {};
    var initialMarginElement = {};
    var percentMarginElement = {};

    var incomeElementVerify = {};
    var percentIncomeElementVerify = {};
    var marginElementVerify = {};
    var initialMarginElementVerify = {};
    var percentMarginElementVerify = {};
    var marginOkElement = {};

    marginOkElement.description = "MARGEM OK/NOT";
    titleElement.description = "Descriçao";

    initialMarginElementVerify.description = "Margem";

    factureHoursVerifyElement.description = "Horas";
    factureSubVerifyElement.description = "Subcontratos";
    factureCostVerifyElement.description = "Despesas Admin";
    facturFactVerifyElement.description = "Factoring";

    factureHoursElement.description = "Horas";
    factureSubElement.description = "Subcontratos";
    factureCostElement.description = "Despesas Admin";
    facturFactElement.description = "Factoring";

    costSubElement.description = "Subcontratos";
    costCostElement.description = "Despesas Admin";
    costFactElement.description = "Factoring";

    costSubVerifyElement.description = "Subcontratos";
    costCostVerifyElement.description = "Despesas Admin";
    costFactVerifyElement.description = "Factoring";

    totalFactureElement.description = "Total a Faturar";
    totalCostElement.description = "Total Custos";

    totalFactureElementVerify.description = "Total a Faturar";
    totalCostElementVerify.description = "Total Custos";

    incomeElement.description = "Income";
    percentIncomeElement.description = "";

    costHoursElement.description = "Custo Horas";
    hoursElement.description = "Horas";

    marginElement.description = "Margem";
    initialMarginElement.description = "Margem";
    percentMarginElement.description = "";

    incomeElementVerify.description = "Income";
    percentIncomeElementVerify.description = "";
    marginElementVerify.description = "Margem";
    percentMarginElementVerify.description = "";

    for (var i = 0; i < departments.length; i++) {
      titleElement[departments[i].nome] = [departments[i].nome];

      marginOkElement[departments[i].nome] = 0;

      factureHoursElement[departments[i].nome] = 0;
      factureSubElement[departments[i].nome] = 0;
      factureCostElement[departments[i].nome] = 0;
      facturFactElement[departments[i].nome] = 0;

      initialMarginElementVerify[departments[i].nome] = 0;

      factureHoursVerifyElement[departments[i].nome] = 0;
      factureSubVerifyElement[departments[i].nome] = 0;
      factureCostVerifyElement[departments[i].nome] = 0;
      facturFactVerifyElement[departments[i].nome] = 0;

      initialMarginElement[departments[i].nome] = 0;

      costSubElement[departments[i].nome] = 0;
      costCostElement[departments[i].nome] = 0;
      costFactElement[departments[i].nome] = 0;

      costSubVerifyElement[departments[i].nome] = 0;
      costCostVerifyElement[departments[i].nome] = 0;
      costFactVerifyElement[departments[i].nome] = 0;

      totalFactureElement[departments[i].nome] = 0;
      totalCostElement[departments[i].nome] = 0;

      totalFactureElementVerify[departments[i].nome] = 0;
      totalCostElementVerify[departments[i].nome] = 0;

      incomeElement[departments[i].nome] = 0;
      percentIncomeElement[departments[i].nome] = 0;

      costHoursElement[departments[i].nome] = 0;
      hoursElement[departments[i].nome] = 0;

      marginElement[departments[i].nome] = 0;
      percentMarginElement[departments[i].nome] = 0;

      incomeElementVerify[departments[i].nome] = 0;
      percentIncomeElementVerify[departments[i].nome] = 0;

      marginElementVerify[departments[i].nome] = 0;
      percentMarginElementVerify[departments[i].nome] = 0;
    }

    titleElement.total = "Total";

    marginOkElement.total = 0;

    initialMarginElementVerify.total = 0;

    initialMarginElement.total = 0;

    costHoursElement.total = 0;

    hoursElement.total = 0;

    percentIncomeElement.total = 0;
    incomeElement.total = 0;
    percentMarginElement.total = 0;
    marginElement.total = 0;

    percentIncomeElementVerify.total = 0;
    incomeElementVerify.total = 0;
    percentMarginElementVerify.total = 0;
    marginElementVerify.total = 0;

    factureHoursElement.total = 0;
    factureSubElement.total = 0;
    factureCostElement.total = 0;
    facturFactElement.total = 0;

    factureHoursVerifyElement.total = 0;
    factureSubVerifyElement.total = 0;
    factureCostVerifyElement.total = 0;
    facturFactVerifyElement.total = 0;

    totalFactureElement.total = 0;

    totalFactureElementVerify.total = 0;

    costSubElement.total = 0;
    costCostElement.total = 0;
    costFactElement.total = 0;

    costSubVerifyElement.total = 0;
    costCostVerifyElement.total = 0;
    costFactVerifyElement.total = 0;

    totalCostElement.total = 0;

    totalCostElementVerify.total = 0;

    factureArray.push(factureHoursElement);
    factureArray.push(factureSubElement);
    factureArray.push(factureCostElement);
    factureArray.push(facturFactElement);

    factureArrayVerify.push(factureHoursVerifyElement);
    factureArrayVerify.push(factureSubVerifyElement);
    factureArrayVerify.push(factureCostVerifyElement);
    factureArrayVerify.push(facturFactVerifyElement);

    costArray.push(costSubElement);
    costArray.push(costCostElement);
    costArray.push(costFactElement);

    costArrayVerify.push(costSubVerifyElement);
    costArrayVerify.push(costCostVerifyElement);
    costArrayVerify.push(costFactVerifyElement);

    buildHoursToFacture();

    for (var i = 0; i < factureArray.length; i++) {
      Object.keys(factureArray[i]).map(
        (key, index) =>
          (totalFactureElement[key] =
            totalFactureElement[key] + factureArray[i][key])
      );
    }

    for (var i = 0; i < factureArrayVerify.length; i++) {
      Object.keys(factureArrayVerify[i]).map(
        (key, index) =>
          (totalFactureElementVerify[key] =
            totalFactureElementVerify[key] + factureArrayVerify[i][key])
      );
    }

    for (var i = 0; i < costArray.length; i++) {
      Object.keys(costArray[i]).map(
        (key, index) =>
          (totalCostElement[key] = totalCostElement[key] + costArray[i][key])
      );
    }

    for (var i = 0; i < costArrayVerify.length; i++) {
      Object.keys(costArrayVerify[i]).map(
        (key, index) =>
          (totalCostElementVerify[key] =
            totalCostElementVerify[key] + costArrayVerify[i][key])
      );
    }

    Object.keys(totalFactureElement).map(
      (key, index) =>
        (incomeElement[key] =
          parseFloat(totalFactureElement[key]) -
          parseFloat(totalCostElement[key]))
    );

    Object.keys(costHoursElement).map((key, index) => {
      if (key != "total" && key != "description") {
        costHoursElement.total = costHoursElement.total + costHoursElement[key];
      }
    });

    Object.keys(hoursElement).map((key, index) => {
      if (key != "total" && key != "description") {
        const hoursStringArray = hoursElement[key].toString().split(".");
        var minutes = "0." + hoursStringArray[1];
        minutes = Math.ceil(parseFloat(minutes) * 60);
        minutes = minutes.toString();
        if (minutes.length === 1) {
          minutes = "0" + minutes;
        }
        hoursElement[key] = hoursStringArray[0] + ":" + minutes;
      }
    });

    Object.keys(hoursElement).map((key, index) => {
      if (key != "total" && key != "description") {
        const hoursArray = hoursElement[key].split(":");
        var newHoras =
          parseFloat(hoursArray[0]) + parseFloat(hoursArray[1]) / 60;
        hoursElement.total = hoursElement.total + newHoras;
      }
    });

    const hoursStringArray = hoursElement.total.toString().split(".");

    var minutes = "0." + hoursStringArray[1];
    minutes = Math.ceil(parseFloat(minutes) * 60);
    minutes = minutes.toString();
    if (minutes.length === 1) {
      minutes = "0" + minutes;
    }
    hoursElement.total = hoursStringArray[0] + ":" + minutes;

    Object.keys(totalFactureElementVerify).map(
      (key, index) =>
        (incomeElementVerify[key] =
          parseFloat(totalFactureElementVerify[key]) -
          parseFloat(totalCostElementVerify[key]))
    );

    Object.keys(incomeElement).map(
      (key, index) =>
        (percentIncomeElement[key] =
          (parseFloat(incomeElement[key]) /
            parseFloat(totalFactureElement[key])) *
          100)
    );

    Object.keys(incomeElementVerify).map((key, index) => {
      if (totalFactureElementVerify[key] != 0) {
        percentIncomeElementVerify[key] =
          (incomeElementVerify[key] / totalFactureElementVerify[key]) * 100;
      }
    });

    var didCalculateMargin = false;
    for (var i = 0; i < workplans[workplanIndex].items.length; i++) {
      for (
        var j = 0;
        j < workplans[workplanIndex].items[i].atividades.length;
        j++
      ) {
        for (
          var k = 0;
          k < workplans[workplanIndex].items[i].atividades[j].opcoes.length;
          k++
        ) {
          if (
            workplans[workplanIndex].items[i].atividades[j].opcoes[k].selected
          ) {
            for (
              var m = 0;
              m <
              workplans[workplanIndex].items[i].atividades[j].opcoes[k].horas
                .length;
              m++
            ) {
              var currentHours =
                workplans[workplanIndex].items[i].atividades[j].opcoes[k].horas[
                  m
                ];
              for (var a = 0; a < departments.length; a++) {
                if (
                  convertIdToName(
                    currentHours.departamentoHoras,
                    "departments"
                  ) === departments[a].nome
                ) {
                  didCalculateMargin = true;
                  const currentCollaborator = collaborators.find(
                    (x) =>
                      x.idColaborador === parseInt(currentHours.colaborador)
                  );

                  const hoursArray = currentHours.horasPropostas.split(":");
                  var newHoras =
                    parseFloat(hoursArray[0]) + parseFloat(hoursArray[1]) / 60;

                  if (getNameFromId() === "Avença") {
                    //newHoras =
                    //  newHoras *
                    //  workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                    //    .horas[m].horasPropostasArray.length;
                  }

                  var value1;
                  var value2;

                  if (
                    currentCollaborator != null &&
                    currentCollaborator != undefined
                  ) {
                    value1 = newHoras * currentCollaborator.precoCompra;
                    value2 =
                      value1 +
                      factureArrayVerify[0][departments[a].nome] * fse +
                      factureArrayVerify[0][departments[a].nome] * gpi;
                  }

                  initialMarginElementVerify[departments[a].nome] =
                    initialMarginElementVerify[departments[a].nome] + value2;

                  initialMarginElement[departments[a].nome] =
                    initialMarginElement[departments[a].nome] +
                    currentHours.custosHoras;
                }
              }
            }
          }
        }
      }
    }

    if (didCalculateMargin === false) {
      for (var i = 0; i < workplans[workplanIndex].items.length; i++) {
        for (
          var j = 0;
          j < workplans[workplanIndex].items[i].atividades.length;
          j++
        ) {
          for (
            var k = 0;
            k < workplans[workplanIndex].items[i].atividades[j].opcoes.length;
            k++
          ) {
            if (k === 0) {
              for (
                var m = 0;
                m <
                workplans[workplanIndex].items[i].atividades[j].opcoes[k].horas
                  .length;
                m++
              ) {
                var currentHours =
                  workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                    .horas[m];
                for (var a = 0; a < departments.length; a++) {
                  if (
                    convertIdToName(
                      currentHours.departamentoHoras,
                      "departments"
                    ) === departments[a].nome
                  ) {
                    didCalculateMargin = true;
                    const currentCollaborator = collaborators.find(
                      (x) =>
                        x.idColaborador === parseInt(currentHours.colaborador)
                    );

                    const hoursArray = currentHours.horasPropostas.split(":");
                    var newHoras =
                      parseFloat(hoursArray[0]) +
                      parseFloat(hoursArray[1]) / 60;

                    if (getNameFromId() === "Avença") {
                      // newHoras =
                      //   newHoras *
                      //   workplans[workplanIndex].items[i].atividades[j].opcoes[
                      //     k
                      //   ].horas[m].horasPropostasArray.length;
                    }
                    var value1;
                    var value2;
                    if (
                      currentCollaborator != null &&
                      currentCollaborator != undefined
                    ) {
                      value1 = newHoras * currentCollaborator.precoCompra;
                      value2 =
                        value1 +
                        factureArrayVerify[0][departments[a].nome] * fse +
                        factureArrayVerify[0][departments[a].nome] * gpi;
                    }

                    initialMarginElementVerify[departments[a].nome] =
                      initialMarginElementVerify[departments[a].nome] + value2;

                    initialMarginElement[departments[a].nome] =
                      initialMarginElement[departments[a].nome] +
                      currentHours.custosHoras;
                  }
                }
              }
            }
          }
        }
      }
    }


    Object.keys(initialMarginElement).map((key, index) => {
      if (key != "total" && key != "description") {
        marginElement[key] =
          parseFloat(incomeElement[key]) -
          parseFloat(initialMarginElement[key]);

        marginElement.total +=
          parseFloat(incomeElement[key]) -
          parseFloat(initialMarginElement[key]);
      }
    });

    Object.keys(initialMarginElementVerify).map((key, index) => {
      if (
        incomeElementVerify[key] != 0 &&
        key != "total" &&
        key != "description"
      ) {
        marginElementVerify[key] =
          parseFloat(incomeElementVerify[key]) -
          initialMarginElementVerify[key];

        marginElementVerify.total +=
          parseFloat(incomeElementVerify[key]) -
          parseFloat(initialMarginElementVerify[key]);
      }
    });

    Object.keys(marginElement).map(
      (key, index) =>
        (percentMarginElement[key] =
          (parseFloat(marginElement[key]) /
            parseFloat(totalFactureElement[key])) *
          100)
    );

    Object.keys(marginElementVerify).map(
      (key, index) =>
        (percentMarginElementVerify[key] =
          (marginElementVerify[key] / totalFactureElementVerify[key]) * 100)
    );

    Object.keys(percentMarginElementVerify).map((key, index) => {
      if (incomeElement[key] === 0) {
        marginOkElement[key] = -1;
      } else if (
        percentMarginElement[key].toFixed(2) <
        percentMarginElementVerify[key].toFixed(2)
      ) {
        marginOkElement[key] = 0;
      } else {
        marginOkElement[key] = 1;
      }
    });

    var monthElement = {};
    monthElement.description = "Rubrica";

    const currentMonths = monthsBtwnDates(
      workplans[workplanIndex].dataInicioProjeto,
      workplans[workplanIndex].dataFinalProjeto
    );

    if (currentMonths === null || currentMonths === undefined) return;

    for (var i = 0; i < currentMonths.length; i++) {
      monthElement[currentMonths[i]] =
        months[parseInt(currentMonths[i].split("-")[1]) - 1] +
        "/" +
        currentMonths[i].split("-")[0];
    }

    monthElement.total = "Total";

    var newTotalFactureElement = {};
    newTotalFactureElement.description = "Faturação";
    var totalFaturacao = 0;

    Object.keys(monthElement).map((key, index) => {
      if (key != "total" && key != "description") {
        if (getNameFromId() === "Avença") {
          newTotalFactureElement[key] = totalFactureElement.total;
          totalFaturacao = totalFaturacao + totalFactureElement.total;
        } else {
          if (
            workplans[workplanIndex].faseFinal === "Inicio" ||
            workplans[workplanIndex].faseFinal === null ||
            workplans[workplanIndex].faseFinal === "" ||
            workplans[workplanIndex].faseFinal === undefined
          ) {
            if (index === 1) {
              newTotalFactureElement[key] = totalFactureElement.total;
              totalFaturacao = totalFaturacao + totalFactureElement.total;
            } else {
              newTotalFactureElement[key] = 0;
            }
          } else if (workplans[workplanIndex].faseFinal === "Repartido") {
            newTotalFactureElement[key] =
              parseFloat(totalFactureElement.total) / currentMonths.length;
            totalFaturacao =
              totalFaturacao +
              parseFloat(totalFactureElement.total) / currentMonths.length;
          } else {
            if (index === currentMonths.length) {
              newTotalFactureElement[key] = totalFactureElement.total;
              totalFaturacao = totalFaturacao + totalFactureElement.total;
            } else {
              newTotalFactureElement[key] = 0;
            }
          }
        }
      }
    });

    newTotalFactureElement.total = totalFaturacao;

    var newTotalCostElement = {};
    newTotalCostElement.description = "Subcontratos e outros custos";
    var totalCustos = 0;

    Object.keys(monthElement).map((key, index) => {
      if (key != "total" && key != "description") {
        if (getNameFromId() === "Avença") {
          newTotalCostElement[key] = totalCostElement.total;
          totalCustos = totalCustos + totalCostElement.total;
        } else {
          if (
            workplans[workplanIndex].faseFinal === "Inicio" ||
            workplans[workplanIndex].faseFinal === null ||
            workplans[workplanIndex].faseFinal === "" ||
            workplans[workplanIndex].faseFinal === undefined
          ) {
            if (index === 1) {
              newTotalCostElement[key] = totalCostElement.total;
              totalCustos = totalCustos + totalCostElement.total;
            } else {
              newTotalCostElement[key] = 0;
            }
          } else if (workplans[workplanIndex].faseFinal === "Repartido") {
            newTotalCostElement[key] =
              parseFloat(totalCostElement.total) / currentMonths.length;
            totalCustos =
              totalCustos +
              parseFloat(totalCostElement.total) / currentMonths.length;
          } else {
            if (index === currentMonths.length) {
              newTotalCostElement[key] = totalCostElement.total;
              totalCustos = totalCustos + totalCostElement.total;
            } else {
              newTotalCostElement[key] = 0;
            }
          }
        }
      }
    });
    newTotalCostElement.total = totalCustos;

    var newTotalIncomeElement = {};
    newTotalIncomeElement.description = "Income";
    var totalIncome = 0;

    Object.keys(monthElement).map((key, index) => {
      if (key != "total" && key != "description") {
        if (getNameFromId() === "Avença") {
          newTotalIncomeElement[key] = incomeElement.total;
          totalIncome = totalIncome + incomeElement.total;
        } else {
          if (
            workplans[workplanIndex].faseFinal === "Inicio" ||
            workplans[workplanIndex].faseFinal === null ||
            workplans[workplanIndex].faseFinal === "" ||
            workplans[workplanIndex].faseFinal === undefined
          ) {
            if (index === 1) {
              newTotalIncomeElement[key] = incomeElement.total;
              totalIncome = totalIncome + incomeElement.total;
            } else {
              newTotalIncomeElement[key] = 0;
            }
          } else if (workplans[workplanIndex].faseFinal === "Repartido") {
            newTotalIncomeElement[key] =
              parseFloat(newTotalFactureElement[key]) -
              parseFloat(newTotalCostElement[key]);
            totalIncome =
              totalIncome +
              parseFloat(newTotalFactureElement[key]) -
              parseFloat(newTotalCostElement[key]);
          } else {
            if (index === currentMonths.length) {
              newTotalIncomeElement[key] = incomeElement.total;
              totalIncome = totalIncome + incomeElement.total;
            } else {
              newTotalIncomeElement[key] = 0;
            }
          }
        }
      }
    });
    newTotalIncomeElement.total = totalIncome;

    var newPercIncomeElement = {};
    newPercIncomeElement.description = "% Income";
    var totalPercIncome = 0;

    Object.keys(monthElement).map((key, index) => {
      if (key != "total" && key != "description") {
        if (getNameFromId() === "Avença") {
          newPercIncomeElement[key] = percentIncomeElement.total;
          totalPercIncome = totalPercIncome + percentIncomeElement.total;
        } else {
          if (
            workplans[workplanIndex].faseFinal === "Inicio" ||
            workplans[workplanIndex].faseFinal === null ||
            workplans[workplanIndex].faseFinal === "" ||
            workplans[workplanIndex].faseFinal === undefined
          ) {
            if (index === 1) {
              newPercIncomeElement[key] = percentIncomeElement.total;
              totalPercIncome = totalPercIncome + percentIncomeElement.total;
            } else {
              newPercIncomeElement[key] = 0;
            }
          } else if (workplans[workplanIndex].faseFinal === "Repartido") {
            newPercIncomeElement[key] =
              (newTotalIncomeElement[key] /
                parseFloat(newTotalFactureElement[key])) *
              100;
            totalPercIncome =
              newTotalIncomeElement.total /
              parseFloat(newTotalFactureElement.total);
          } else {
            if (index === currentMonths.length) {
              newPercIncomeElement[key] = percentIncomeElement.total;
              totalPercIncome = totalPercIncome + percentIncomeElement.total;
            } else {
              newPercIncomeElement[key] = 0;
            }
          }
        }
      }
    });
    newPercIncomeElement.total = percentIncomeElement.total;

    var newCostHoursElement = {};
    newCostHoursElement.description = "Custo das Horas";
    var totalCostHours = 0;

    var totalHoursAdded = [];
    var totalCostAdded = 0;
    var hoursAvenca = 0;
    var totalHoursAvenca = 0;
    for (var i = 0; i < currentMonths.length; i++) {
      totalHoursAdded[i] = 0;
    }
    for (var i = 0; i < workplans[workplanIndex].items.length; i++) {
      for (
        var j = 0;
        j < workplans[workplanIndex].items[i].atividades.length;
        j++
      ) {
        for (
          var k = 0;
          k < workplans[workplanIndex].items[i].atividades[j].opcoes.length;
          k++
        ) {
          if (
            workplans[workplanIndex].items[i].atividades[j].opcoes[k].selected
          ) {
            for (
              var m = 0;
              m <
              workplans[workplanIndex].items[i].atividades[j].opcoes[k].horas
                .length;
              m++
            ) {
              var currentHours =
                workplans[workplanIndex].items[i].atividades[j].opcoes[k].horas[
                  m
                ];

              totalCostAdded =
                totalCostAdded + parseFloat(currentHours.custosHoras);
              hoursAvenca =
                hoursAvenca +
                parseFloat(currentHours.horasPropostas.split(":")[0]) +
                parseFloat(currentHours.horasPropostas.split(":")[1]) / 60;
              for (
                var u = 0;
                u < currentHours.horasPropostasArray.length;
                u++
              ) {
                totalHoursAdded[u] =
                  totalHoursAdded[u] +
                  parseFloat(
                    currentHours.horasPropostasArray[u].hoursValue.split(":")[0]
                  ) +
                  parseFloat(
                    currentHours.horasPropostasArray[u].hoursValue.split(":")[1]
                  ) /
                    60;
              }
            }
          }
        }
      }
    }

    var totalHoras = 0;
    for (var i = 0; i < totalHoursAdded.length; i++) {
      totalHoras = totalHoras + totalHoursAdded[i];
    }

    Object.keys(monthElement).map((key, index) => {
      if (key != "total" && key != "description") {
        if (getNameFromId() === "Avença") {
          newCostHoursElement[key] = totalCostAdded;
          totalCostHours = totalCostHours + totalCostAdded;
        } else {
          if (
            workplans[workplanIndex].faseFinal === "Inicio" ||
            workplans[workplanIndex].faseFinal === null ||
            workplans[workplanIndex].faseFinal === "" ||
            workplans[workplanIndex].faseFinal === undefined
          ) {
            if (index === 1) {
              newCostHoursElement[key] = totalCostAdded;
              totalCostHours = totalCostHours + totalCostAdded;
            } else {
              newCostHoursElement[key] = 0;
            }
          } else if (workplans[workplanIndex].faseFinal === "Repartido") {
            newCostHoursElement[key] = totalCostAdded / currentMonths.length;
            totalCostHours = totalCostAdded;
          } else {
            if (index === currentMonths.length) {
              newCostHoursElement[key] = totalCostAdded;
              totalCostHours = totalCostHours + totalCostAdded;
            } else {
              newCostHoursElement[key] = 0;
            }
          }
        }
      }
    });
    newCostHoursElement.total = totalCostHours;

    var newHoursElement = {};
    newHoursElement.description = "Horas";
    var totalHours = 0;

    Object.keys(monthElement).map((key, index) => {
      if (key != "total" && key != "description") {
        if (getNameFromId() === "Avença") {
          var n = new Date(0, 0);
          n.setSeconds(+hoursAvenca * 60 * 60);
          const hoursStringArray = hoursAvenca.toString().split(".");
          var minutes = "0." + hoursStringArray[1];
          minutes = Math.ceil(parseFloat(minutes) * 60);
          minutes = minutes.toString();
          if (minutes.length === 1) {
            minutes = "0" + minutes;
          }
          newHoursElement[key] = hoursStringArray[0] + ":" + minutes;
          totalHours =
            totalHours +
            parseInt(hoursElement.total.split(":")[0]) +
            parseInt(hoursElement.total.split(":")[1]) / 60;
        } else {
          if (
            workplans[workplanIndex].faseFinal === "Inicio" ||
            workplans[workplanIndex].faseFinal === null ||
            workplans[workplanIndex].faseFinal === "" ||
            workplans[workplanIndex].faseFinal === undefined
          ) {
            if (index === 1) {
              const hoursStringArray = totalHoras.toString().split(".");
              var minutes = "0." + hoursStringArray[1];
              minutes = Math.ceil(parseFloat(minutes) * 60);
              minutes = minutes.toString();
              if (minutes.length === 1) {
                minutes = "0" + minutes;
              }
              newHoursElement[key] = hoursStringArray[0] + ":" + minutes;
            } else {
              newHoursElement[key] = 0;
            }
          } else if (workplans[workplanIndex].faseFinal === "Repartido") {
            var n = new Date(0, 0);
            n.setSeconds(+totalHoursAdded[index - 1] * 60 * 60);
            const hoursStringArray = totalHoursAdded[index - 1]
              .toString()
              .split(".");
            var minutes = "0." + hoursStringArray[1];
            minutes = Math.ceil(parseFloat(minutes) * 60);
            minutes = minutes.toString();
            if (minutes.length === 1) {
              minutes = "0" + minutes;
            }
            const newHours = hoursStringArray[0] + ":" + minutes;
            newHoursElement[key] = newHours;
          } else {
            if (index === currentMonths.length) {
              const hoursStringArray = totalHoras.toString().split(".");
              var minutes = "0." + hoursStringArray[1];
              minutes = Math.ceil(parseFloat(minutes) * 60);
              minutes = minutes.toString();
              if (minutes.length === 1) {
                minutes = "0" + minutes;
              }
              newHoursElement[key] = hoursStringArray[0] + ":" + minutes;
            } else {
              newHoursElement[key] = 0;
            }
          }
        }
      }
    });

    if (getNameFromId() === "Avença") {
      const hoursStringArray = totalHoras.toString().split(".");
      var minutes = "0." + hoursStringArray[1];
      minutes = Math.ceil(parseFloat(minutes) * 60);
      minutes = minutes.toString();
      if (minutes.length === 1) {
        minutes = "0" + minutes;
      }
      newHoursElement.total = hoursStringArray[0] + ":" + minutes;
    } else {
      const hoursStringArray = totalHoras.toString().split(".");
      var minutes = "0." + hoursStringArray[1];
      minutes = Math.ceil(parseFloat(minutes) * 60);
      minutes = minutes.toString();
      if (minutes.length === 1) {
        minutes = "0" + minutes;
      }
      newHoursElement.total = hoursStringArray[0] + ":" + minutes;
    }

    var newMarginElement = {};
    newMarginElement.description = "Margem";
    var totalMargin = 0;

    Object.keys(monthElement).map((key, index) => {
      if (key != "total" && key != "description") {
        if (getNameFromId() === "Avença") {
          newMarginElement[key] =
            newTotalIncomeElement[key] - newCostHoursElement[key];
          totalMargin = totalMargin + marginElement.total;
        } else {
          if (
            workplans[workplanIndex].faseFinal === "Inicio" ||
            workplans[workplanIndex].faseFinal === null ||
            workplans[workplanIndex].faseFinal === "" ||
            workplans[workplanIndex].faseFinal === undefined
          ) {
            if (index === 1) {
              newMarginElement[key] =
                newTotalIncomeElement.total - newCostHoursElement.total;
              totalMargin = totalMargin + marginElement.total;
            } else {
              newMarginElement[key] = 0;
            }
          } else if (workplans[workplanIndex].faseFinal === "Repartido") {
            newMarginElement[key] =
              newTotalIncomeElement[key] - newCostHoursElement[key];
            //newMarginElement.total = newMarginElement.total + newTotalIncomeElement[key]- newCostHoursElement[key]
          } else {
            if (index === currentMonths.length) {
              newMarginElement[key] =
                newTotalIncomeElement.total - newCostHoursElement.total;
              totalMargin = totalMargin + marginElement.total;
            } else {
              newMarginElement[key] = 0;
            }
          }
        }
      }
    });
    newMarginElement.total =
      newTotalIncomeElement.total - newCostHoursElement.total;

    var newPercMargin = {};
    newPercMargin.description = "% Margem";
    var totalPercIncome = 0;
    Object.keys(monthElement).map((key, index) => {
      if (key != "total" && key != "description") {
        if (getNameFromId() === "Avença") {
          newPercMargin[key] =
            (newMarginElement[key] / newTotalFactureElement[key]) * 100;
          totalPercIncome =
            newMarginElement.total / newTotalFactureElement.total;
        } else {
          if (
            workplans[workplanIndex].faseFinal === "Inicio" ||
            workplans[workplanIndex].faseFinal === null ||
            workplans[workplanIndex].faseFinal === "" ||
            workplans[workplanIndex].faseFinal === undefined
          ) {
            if (index === 1) {
              newPercMargin[key] =
                (newMarginElement[key] / newTotalFactureElement[key]) * 100;
              totalPercIncome = totalPercIncome + percentMarginElement.total;
            } else {
              newPercMargin[key] = 0;
            }
          } else if (workplans[workplanIndex].faseFinal === "Repartido") {
            newPercMargin[key] =
              (newMarginElement[key] / newTotalFactureElement[key]) * 100;
            //newMarginElement.total = newMarginElement.total + newTotalIncomeElement[key]- newCostHoursElement[key]
          } else {
            if (index === currentMonths.length) {
              newPercMargin[key] =
                (newMarginElement[key] / newTotalFactureElement[key]) * 100;
              totalPercIncome = totalPercIncome + percentMarginElement.total;
            } else {
              newPercMargin[key] = 0;
            }
          }
        }
      }
    });
    newPercMargin.total =
      (newMarginElement.total / newTotalFactureElement.total) * 100;

    totalFactureElementVerify.description = "Total a faturar";

    totalCostElementVerify.description = "Total Custos";

    incomeElementVerify.description = "Income";
    percentIncomeElementVerify.description = "";

    marginElementVerify.description = "Margem";
    percentMarginElementVerify.description = "";

    marginElement.description = "Margem";
    percentMarginElement.description = "";
    incomeElement.description = "Income";
    percentIncomeElement.description = "";
    totalFactureElement.description = "Total a Faturar";
    totalCostElement.description = "Total Custos";

    workplans[workplanIndex].simulador.horasPropInicial =
      factureHoursElement.total;
    workplans[workplanIndex].simulador.subcontratosPropInicial =
      factureSubElement.total;
    workplans[workplanIndex].simulador.despesasPropInicial =
      factureCostElement.total;
    workplans[workplanIndex].simulador.factoringPropInicial =
      facturFactElement.total;
    workplans[workplanIndex].simulador.totalPropInicial =
      totalFactureElement.total;

    workplans[workplanIndex].simulador.horasValSugerido =
      factureHoursElement.total *
      (parseFloat(workplans[workplanIndex].simulador.valorLimite) /
        totalFactureElement.total);
    workplans[workplanIndex].simulador.subcontratosValSugerido =
      factureSubElement.total *
      (parseFloat(workplans[workplanIndex].simulador.valorLimite) /
        totalFactureElement.total);
    workplans[workplanIndex].simulador.despesasValSugerido =
      factureCostElement.total *
      (parseFloat(workplans[workplanIndex].simulador.valorLimite) /
        totalFactureElement.total);
    workplans[workplanIndex].simulador.factoringValSugerido =
      facturFactElement.total *
      (parseFloat(workplans[workplanIndex].simulador.valorLimite) /
        totalFactureElement.total);
    workplans[workplanIndex].simulador.totalValSugerido = parseFloat(
      workplans[workplanIndex].simulador.valorLimite
    );

    if (workplans[workplanIndex].simulador.horasOutroValor === 0) {
      workplans[workplanIndex].simulador.horasValorConsiderar =
        workplans[workplanIndex].simulador.horasValSugerido;
    } else {
      workplans[workplanIndex].simulador.horasValorConsiderar = parseFloat(
        workplans[workplanIndex].simulador.horasOutroValor
      );
    }

    if (workplans[workplanIndex].simulador.subcontratosOutroValor === 0) {
      workplans[workplanIndex].simulador.subcontratosValorConsiderar =
        workplans[workplanIndex].simulador.subcontratosValSugerido;
    } else {
      workplans[workplanIndex].simulador.subcontratosValorConsiderar =
        parseFloat(workplans[workplanIndex].simulador.subcontratosOutroValor);
    }

    if (workplans[workplanIndex].simulador.despesasOutroValor === 0) {
      workplans[workplanIndex].simulador.despesasValorConsiderar =
        workplans[workplanIndex].simulador.despesasValSugerido;
    } else {
      workplans[workplanIndex].simulador.despesasValorConsiderar = parseFloat(
        workplans[workplanIndex].simulador.despesasOutroValor
      );
    }

    workplans[workplanIndex].simulador.factoringValorConsiderar = parseFloat(
      workplans[workplanIndex].simulador.factoringValSugerido
    );

    workplans[workplanIndex].simulador.totalValorConsiderar =
      workplans[workplanIndex].simulador.horasValorConsiderar +
      workplans[workplanIndex].simulador.subcontratosValorConsiderar +
      workplans[workplanIndex].simulador.despesasValorConsiderar +
      workplans[workplanIndex].simulador.factoringValorConsiderar;

    setFinalResult(
      workplans[workplanIndex].simulador.totalValorConsiderar -
        workplans[workplanIndex].simulador.totalValSugerido
    );

    dispatch(setAllWorkplans(workplans));
  }, [workplans, triggerLoading]);

  function convertIdToName(id, name) {
    if (name === "departments") {
      const dep = departments.find((x) => x.idDepartamento === parseInt(id));
      if (dep != null) return dep?.nome;
    }
    if (name === "paymentTypes" && paymentTypes != null) {
      const payType = paymentTypes.find(
        (x) => x.idTipoPagamento === parseInt(id)
      );
      if (payType != null) return payType?.nome;
    }
  }

  function buildHoursToFacture() {
    var hasSelected = false;
    for (var i = 0; i < workplans[workplanIndex].items.length; i++) {
      for (
        var j = 0;
        j < workplans[workplanIndex].items[i].atividades.length;
        j++
      ) {
        for (
          var k = 0;
          k < workplans[workplanIndex].items[i].atividades[j].opcoes.length;
          k++
        ) {
          if (
            workplans[workplanIndex].items[i].atividades[j].opcoes[k].selected
          ) {
            hasSelected = true;

            for (
              var m = 0;
              m <
              workplans[workplanIndex].items[i].atividades[j].opcoes[k].horas
                .length;
              m++
            ) {
              var currentHours =
                workplans[workplanIndex].items[i].atividades[j].opcoes[k].horas[
                  m
                ];

              for (var a = 0; a < departments.length; a++) {
                if (
                  convertIdToName(
                    currentHours.departamentoHoras,
                    "departments"
                  ) === departments[a].nome
                ) {
                  factureArray[0].total =
                    factureArray[0].total +
                    parseFloat(currentHours.valorVendaHoras);
                  factureArray[0][departments[a].nome] =
                    factureArray[0][departments[a].nome] +
                    parseFloat(currentHours.valorVendaHoras);

                  const currentCollaborator = collaborators.find(
                    (x) =>
                      x.idColaborador === parseInt(currentHours.colaborador)
                  );

                  const hoursArray = currentHours.horasPropostas.split(":");
                  var newHoras =
                    parseFloat(hoursArray[0]) + parseFloat(hoursArray[1]) / 60;

                  hoursElement[departments[a].nome] = (
                    parseFloat(hoursElement[departments[a].nome]) + newHoras
                  ).toFixed(2);
                  if (
                    typeof currentHours.custosHoras === "string" ||
                    currentHours.custosHoras instanceof String
                  ) {
                    costHoursElement[departments[a].nome] =
                      costHoursElement[departments[a].nome] +
                      parseFloat(currentHours.custosHoras);
                  } else {
                    costHoursElement[departments[a].nome] =
                      costHoursElement[departments[a].nome] +
                      currentHours.custosHoras;
                  }
                  if (
                    typeof costHoursElement[departments[a].nome] === "string" ||
                    costHoursElement[departments[a].nome] instanceof String
                  ) {
                    costHoursElement[departments[a].nome] = parseFloat(
                      costHoursElement[departments[a].nome]
                    );
                  }

                  if (getNameFromId() === "Avença") {
                    // newHoras =
                    //   newHoras *
                    //   workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                    //     .horas[m].horasPropostasArray.length;
                  }
                  var value1;
                  var value2;

                  if (
                    currentCollaborator != null &&
                    currentCollaborator != undefined
                  ) {
                    value1 = newHoras * currentCollaborator.precoCompra;
                    value2 = value1 / gpd;
                  }

                  if (value2 > parseFloat(currentHours.valorVendaHoras)) {
                    factureArrayVerify[0][departments[a].nome] =
                      factureArrayVerify[0][departments[a].nome] +
                      parseFloat(currentHours.valorVendaHoras);
                    factureArrayVerify[0].total =
                      factureArrayVerify[0].total +
                      parseFloat(currentHours.valorVendaHoras);
                  } else {
                    factureArrayVerify[0][departments[a].nome] =
                      factureArrayVerify[0][departments[a].nome] +
                      parseFloat(value2);
                    factureArrayVerify[0].total =
                      factureArrayVerify[0].total + parseFloat(value2);
                  }
                }
              }
            }

            for (
              var m = 0;
              m <
              workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                .fornecedores.length;
              m++
            ) {
              var currentSuppliers =
                workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                  .fornecedores[m];
              for (var a = 0; a < departments.length; a++) {
                if (
                  convertIdToName(
                    currentSuppliers.departamentoForn,
                    "departments"
                  ) === departments[a].nome
                ) {
                  factureArray[1].total =
                    factureArray[1].total +
                    parseFloat(currentSuppliers.valorVendaForn);

                  factureArray[1][departments[a].nome] =
                    factureArray[1][departments[a].nome] +
                    parseFloat(currentSuppliers.valorVendaForn);

                  if (
                    currentSuppliers.precoCompraForn != 0 &&
                    currentSuppliers.precoCompraForn != null &&
                    currentSuppliers.precoCompraForn != undefined
                  ) {
                    const currentSupplier = providerTypes.find(
                      (x) =>
                        x.idTipoFornecedor === currentSuppliers.tipoFornecedor
                    );

                    factureArrayVerify[1].total =
                      factureArrayVerify[1].total +
                      parseFloat(
                        currentSuppliers.precoCompraForn /
                          (1 - currentSupplier.percentagem / 100)
                      );

                    factureArrayVerify[1][departments[a].nome] =
                      factureArrayVerify[1][departments[a].nome] +
                      parseFloat(
                        currentSuppliers.precoCompraForn /
                          (1 - currentSupplier.percentagem / 100)
                      );

                    costArrayVerify[0].total =
                      costArrayVerify[0].total +
                      parseFloat(currentSuppliers.precoCompraForn);

                    costArrayVerify[0][departments[a].nome] =
                      costArrayVerify[0][departments[a].nome] +
                      parseFloat(currentSuppliers.precoCompraForn);
                  }

                  costArray[0].total =
                    costArray[0].total +
                    parseFloat(currentSuppliers.precoCompraForn);

                  costArray[0][departments[a].nome] =
                    costArray[0][departments[a].nome] +
                    parseFloat(currentSuppliers.precoCompraForn);
                }
              }
            }
            for (
              var m = 0;
              m <
              workplans[workplanIndex].items[i].atividades[j].opcoes[k].despesas
                .length;
              m++
            ) {
              var currentCosts =
                workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                  .despesas[m];
              for (var a = 0; a < departments.length; a++) {
                if (
                  convertIdToName(
                    currentCosts.departamentoDesp,
                    "departments"
                  ) === departments[a].nome
                ) {
                  factureArray[2].total =
                    factureArray[2].total +
                    parseFloat(currentCosts.valorVendaDesp);

                  factureArray[2][departments[a].nome] =
                    factureArray[2][departments[a].nome] +
                    parseFloat(currentCosts.valorVendaDesp);

                  if (
                    currentCosts.precoCompraForn != 0 &&
                    currentCosts.precoCompraForn != null &&
                    currentCosts.precoCompraForn != undefined
                  ) {
                    const currentExpense = expenditureTypes.find(
                      (x) =>
                        x.idTipoDespesa === parseInt(currentCosts.tipoDespesa)
                    );
                    factureArrayVerify[2].total =
                      factureArrayVerify[2].total +
                      parseFloat(
                        currentCosts.precoCompraForn /
                          (1 - currentExpense.percentagem / 100)
                      );

                    factureArrayVerify[2][departments[a].nome] =
                      factureArrayVerify[2][departments[a].nome] +
                      parseFloat(
                        currentCosts.precoCompraForn /
                          (1 - currentExpense.percentagem / 100)
                      );

                    costArrayVerify[1].total =
                      costArrayVerify[1].total +
                      parseFloat(currentCosts.precoCompraForn);

                    costArrayVerify[1][departments[a].nome] =
                      costArrayVerify[1][departments[a].nome] +
                      parseFloat(currentCosts.precoCompraForn);
                  }

                  costArray[1].total =
                    costArray[1].total +
                    parseFloat(currentCosts.precoCompraForn);

                  costArray[1][departments[a].nome] =
                    costArray[1][departments[a].nome] +
                    parseFloat(currentCosts.precoCompraForn);
                }
              }
            }
          }
        }
      }
    }

    if (!hasSelected) {
      for (var i = 0; i < workplans[workplanIndex].items.length; i++) {
        for (
          var j = 0;
          j < workplans[workplanIndex].items[i].atividades.length;
          j++
        ) {
          for (
            var k = 0;
            k < workplans[workplanIndex].items[i].atividades[j].opcoes.length;
            k++
          ) {
            if (k === 0) {
              for (
                var m = 0;
                m <
                workplans[workplanIndex].items[i].atividades[j].opcoes[k].horas
                  .length;
                m++
              ) {
                var currentHours =
                  workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                    .horas[m];
                for (var a = 0; a < departments.length; a++) {
                  if (
                    convertIdToName(
                      currentHours.departamentoHoras,
                      "departments"
                    ) === departments[a].nome
                  ) {
                    factureArray[0].total =
                      factureArray[0].total +
                      parseFloat(currentHours.valorVendaHoras);
                    factureArray[0][departments[a].nome] =
                      factureArray[0][departments[a].nome] +
                      parseFloat(currentHours.valorVendaHoras);

                    const currentCollaborator = collaborators.find(
                      (x) =>
                        x.idColaborador === parseInt(currentHours.colaborador)
                    );

                    const hoursArray = currentHours.horasPropostas.split(":");
                    var newHoras =
                      parseFloat(hoursArray[0]) +
                      parseFloat(hoursArray[1]) / 60;

                    hoursElement[departments[a].nome] = (
                      parseFloat(hoursElement[departments[a].nome]) + newHoras
                    ).toFixed(2);

                    if (
                      typeof currentHours.custosHoras === "string" ||
                      currentHours.custosHoras instanceof String
                    ) {
                      costHoursElement[departments[a].nome] =
                        costHoursElement[departments[a].nome] +
                        parseFloat(currentHours.custosHoras);
                    } else {
                      costHoursElement[departments[a].nome] =
                        costHoursElement[departments[a].nome] +
                        currentHours.custosHoras;
                    }
                    if (
                      typeof costHoursElement[departments[a].nome] ===
                        "string" ||
                      costHoursElement[departments[a].nome] instanceof String
                    ) {
                      costHoursElement[departments[a].nome] = parseFloat(
                        costHoursElement[departments[a].nome]
                      );
                    }

                    if (getNameFromId() === "Avença") {
                      //  newHoras =
                      //    newHoras *
                      //    workplans[workplanIndex].items[i].atividades[j].opcoes[
                      //      k
                      //    ].horas[m].horasPropostasArray.length;
                    }
                    var value1;
                    var value2;

                    if (
                      currentCollaborator != null &&
                      currentCollaborator != undefined
                    ) {
                      value1 = newHoras * currentCollaborator.precoCompra;
                      value2 = value1 / gpd;
                    }

                    if (value2 > parseFloat(currentHours.valorVendaHoras)) {
                      factureArrayVerify[0][departments[a].nome] =
                        factureArrayVerify[0][departments[a].nome] +
                        parseFloat(currentHours.valorVendaHoras);
                      factureArrayVerify[0].total =
                        factureArrayVerify[0].total +
                        parseFloat(currentHours.valorVendaHoras);
                    } else {
                      factureArrayVerify[0][departments[a].nome] =
                        factureArrayVerify[0][departments[a].nome] +
                        parseFloat(value2);
                      factureArrayVerify[0].total =
                        factureArrayVerify[0].total + parseFloat(value2);
                    }
                  }
                }
              }

              for (
                var m = 0;
                m <
                workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                  .fornecedores.length;
                m++
              ) {
                var currentSuppliers =
                  workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                    .fornecedores[m];
                for (var a = 0; a < departments.length; a++) {
                  if (
                    convertIdToName(
                      currentSuppliers.departamentoForn,
                      "departments"
                    ) === departments[a].nome
                  ) {
                    factureArray[1].total =
                      factureArray[1].total +
                      parseFloat(currentSuppliers.valorVendaForn);

                    factureArray[1][departments[a].nome] =
                      factureArray[1][departments[a].nome] +
                      parseFloat(currentSuppliers.valorVendaForn);

                    costArray[0].total =
                      costArray[0].total +
                      parseFloat(currentSuppliers.precoCompraForn);

                    costArray[0][departments[a].nome] =
                      costArray[0][departments[a].nome] +
                      parseFloat(currentSuppliers.precoCompraForn);

                    if (
                      currentSuppliers.precoCompraForn != 0 &&
                      currentSuppliers.precoCompraForn != null &&
                      currentSuppliers.precoCompraForn != undefined
                    ) {
                      const currentSupplier = providerTypes.find(
                        (x) =>
                          x.idTipoFornecedor === currentSuppliers.tipoFornecedor
                      );

                      factureArrayVerify[1].total =
                        factureArrayVerify[1].total +
                        parseFloat(
                          currentSuppliers.precoCompraForn /
                            (1 - currentSupplier.percentagem / 100)
                        );

                      factureArrayVerify[1][departments[a].nome] =
                        factureArrayVerify[1][departments[a].nome] +
                        parseFloat(
                          currentSuppliers.precoCompraForn /
                            (1 - currentSupplier.percentagem / 100)
                        );

                      costArrayVerify[0].total =
                        costArrayVerify[0].total +
                        parseFloat(currentSuppliers.precoCompraForn);

                      costArrayVerify[0][departments[a].nome] =
                        costArrayVerify[0][departments[a].nome] +
                        parseFloat(currentSuppliers.precoCompraForn);
                    }
                  }
                }
              }
              for (
                var m = 0;
                m <
                workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                  .despesas.length;
                m++
              ) {
                var currentCosts =
                  workplans[workplanIndex].items[i].atividades[j].opcoes[k]
                    .despesas[m];
                for (var a = 0; a < departments.length; a++) {
                  if (
                    convertIdToName(
                      currentCosts.departamentoDesp,
                      "departments"
                    ) === departments[a].nome
                  ) {
                    factureArray[2].total =
                      factureArray[2].total +
                      parseFloat(currentCosts.valorVendaDesp);

                    factureArray[2][departments[a].nome] =
                      factureArray[2][departments[a].nome] +
                      parseFloat(currentCosts.valorVendaDesp);

                    costArray[1].total =
                      costArray[1].total +
                      parseFloat(currentCosts.precoCompraForn);

                    costArray[1][departments[a].nome] =
                      costArray[1][departments[a].nome] +
                      parseFloat(currentCosts.precoCompraForn);

                    if (
                      currentCosts.precoCompraForn != 0 &&
                      currentCosts.precoCompraForn != null &&
                      currentCosts.precoCompraForn != undefined
                    ) {
                      const currentExpense = expenditureTypes.find(
                        (x) =>
                          x.idTipoDespesa === parseInt(currentCosts.tipoDespesa)
                      );
                      factureArrayVerify[2].total =
                        factureArrayVerify[2].total +
                        parseFloat(
                          currentCosts.precoCompraForn /
                            (1 - currentExpense.percentagem / 100)
                        );

                      factureArrayVerify[2][departments[a].nome] =
                        factureArrayVerify[2][departments[a].nome] +
                        parseFloat(
                          currentCosts.precoCompraForn /
                            (1 - currentExpense.percentagem / 100)
                        );

                      costArrayVerify[1].total =
                        costArrayVerify[1].total +
                        parseFloat(currentCosts.precoCompraForn);

                      costArrayVerify[1][departments[a].nome] =
                        costArrayVerify[1][departments[a].nome] +
                        parseFloat(currentCosts.precoCompraForn);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    var totalCostProportionElement = {};
    var totalCostProportionElementVerify = {};
    totalCostProportionElement.description = "DESCRIÇÃO";
    for (var i = 0; i < departments.length; i++) {
      totalCostProportionElement[departments[i].nome] = 0;
      totalCostProportionElementVerify[departments[i].nome] = 0;
    }
    totalCostProportionElement.total = 0;
    totalCostProportionElementVerify.total = 0;

    for (var i = 0; i < factureArray.length - 1; i++) {
      Object.keys(factureArray[i]).map(
        (key, index) =>
          (totalCostProportionElement[key] =
            totalCostProportionElement[key] + factureArray[i][key])
      );

      Object.keys(factureArrayVerify[i]).map(
        (key, index) =>
          (totalCostProportionElementVerify[key] =
            totalCostProportionElementVerify[key] + factureArrayVerify[i][key])
      );
    }

    var factName = convertIdToName(
      workplans[workplanIndex].formaPagamento,
      "paymentTypes"
    );
    const fact = factoring.find((x) => x.nome === factName);

    if (fact != null && fact != undefined) {
      const juro =
        ((totalCostProportionElement.total *
          1.23 *
          (fact.percentAdiantamento / 100) *
          (fact.txJuroEfetiva / 100)) /
          360) *
        parseFloat(workplans[workplanIndex].prazoPagamento);
      const impstSJuro = juro * (fact.impostoSeloComissao / 100);
      const comGestao =
        totalCostProportionElement.total * 1.23 * (fact.comissaoGestao / 100);
      const impsCJuro = comGestao * (fact.impostoSeloComissao / 100);
      const totalFactoring = juro + impsCJuro + impstSJuro + comGestao;

      const juroVerify =
        ((totalCostProportionElementVerify.total *
          1.23 *
          (fact.percentAdiantamento / 100) *
          (fact.txJuroEfetiva / 100)) /
          360) *
        parseFloat(workplans[workplanIndex].prazoPagamento);
      const impstSJuroVerify = juroVerify * (fact.impostoSeloComissao / 100);
      const comGestaoVerify =
        totalCostProportionElementVerify.total *
        1.23 *
        (fact.comissaoGestao / 100);
      const impsCJuroVerify =
        comGestaoVerify * (fact.impostoSeloComissao / 100);
      const totalFactoringVerify =
        juroVerify + impsCJuroVerify + impstSJuroVerify + comGestaoVerify;

      Object.keys(costArray[2]).map((key, index) => {
        if (key != "total")
          costArray[2][key] =
            costArray[2][key] +
            parseFloat(
              (totalCostProportionElement[key] /
                totalCostProportionElement.total) *
                totalFactoring
            );
        if (key != "description" && key != "total")
          costArray[2].total = costArray[2].total + costArray[2][key];
      });

      Object.keys(costArrayVerify[2]).map((key, index) => {
        if (key != "total")
          costArrayVerify[2][key] =
            costArrayVerify[2][key] +
            parseFloat(
              (totalCostProportionElementVerify[key] /
                totalCostProportionElementVerify.total) *
                totalFactoringVerify
            );

        if (key != "description" && key != "total")
          costArrayVerify[2].total =
            costArrayVerify[2].total + costArrayVerify[2][key];
      });

      costArrayVerify[2].description = "Factoring";
      costArray[2].description = "Factoring";

      if (fact && workplans[workplanIndex].aceitarFormaPagamento === "Sim") {
        Object.keys(costArray[2]).map(
          (key, index) =>
            (factureArray[3][key] = costArray[2][key] / (1 - fact.margemPV))
        );

        Object.keys(costArrayVerify[2]).map(
          (key, index) =>
            (factureArrayVerify[3][key] =
              costArrayVerify[2][key] / (1 - fact.margemPV))
        );
      }
      factureArray[3].description = "Factoring";
      factureArrayVerify[3].description = "Factoring";
    }
  }

  return (
    <div className="liftworld-item-main-wrapper">
      <div style={{ width: "100%", padding: "30px" }} ref={componentRef}>
        <div className="liftworld-image-text-wrapper">
          <div className="liftworld-text-large">Simulador</div>
        </div>
        <div style={{ maxWidth: "30%" }}>
          <Input
            field={buildInputField(
              "Valor Limite do Cliente",
              workplans[workplanIndex].simulador.valorLimite
            )}
            workplanIndex={workplanIndex}
            key={uuid()}
            color={"option"}
            size={"large-size"}
            name={"simulador.valorLimite"}
          />
        </div>
        <div style={{ paddingTop: "20px" }} />
        <div className="liftworld-image-text-wrapper">
          <div className="liftworld-text-large">Valores dos Sub-limites</div>
        </div>
        <div style={{ maxWidth: "60%" }}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <div
              className={
                `${"liftworld-simulator-table-header-element-20"} ` + "start"
              }
            >
              {"Proposta Inicial"}
            </div>
            <div
              className={
                `${"liftworld-simulator-table-header-element-20"} ` + "middle"
              }
            >
              {"Valores sugeridos"}
            </div>
            <div
              className={
                `${"liftworld-simulator-table-header-element-20"} ` + "middle"
              }
            >
              {"Sugestão Outro Valor"}
            </div>
            <div
              className={
                `${"liftworld-simulator-table-header-element-20"} ` + "end"
              }
            >
              {"Valor a Considerar"}
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              className={
                `${"liftworld-simulator-table-header-element-20"} ` + "start"
              }
            >
              {"Horas"}
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[workplanIndex].simulador.horasPropInicial.toFixed(
                      2
                    )
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[workplanIndex].simulador.horasValSugerido.toFixed(
                      2
                    )
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableInput
                field={buildInputField(
                  "",
                  workplans[workplanIndex].simulador.horasOutroValor
                )}
                size={"large"}
                position={"middle"}
                key={uuid()}
                workplanIndex={workplanIndex}
                name={"simulador.horasOutroValor"}
                number={"number"}
                euro={true}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.horasValorConsiderar.toFixed(2)
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              className={
                `${"liftworld-simulator-table-header-element-20"} ` + "middle"
              }
            >
              {"Subcontratos"}
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.subcontratosPropInicial.toFixed(2)
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.subcontratosValSugerido.toFixed(2)
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableInput
                field={buildInputField(
                  "",
                  workplans[workplanIndex].simulador.subcontratosOutroValor
                )}
                size={"large"}
                position={"middle"}
                key={uuid()}
                workplanIndex={workplanIndex}
                name={"simulador.subcontratosOutroValor"}
                number={"number"}
                euro={true}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.subcontratosValorConsiderar.toFixed(2)
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              className={
                `${"liftworld-simulator-table-header-element-20"} ` + "middle"
              }
            >
              {"Despesas/Custos Admin"}
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.despesasPropInicial.toFixed(2)
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.despesasValSugerido.toFixed(2)
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableInput
                field={buildInputField(
                  "",
                  workplans[workplanIndex].simulador.despesasOutroValor
                )}
                size={"large"}
                position={"middle"}
                key={uuid()}
                workplanIndex={workplanIndex}
                name={"simulador.despesasOutroValor"}
                number={"number"}
                euro={true}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.despesasValorConsiderar.toFixed(2)
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              className={
                `${"liftworld-simulator-table-header-element-20"} ` +
                "bottom-start"
              }
            >
              {"Factoring"}
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.factoringPropInicial.toFixed(2)
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.factoringValSugerido.toFixed(2)
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={""}
                position={"middle"}
                number={"number"}
                color={"colored"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.factoringValorConsiderar.toFixed(2)
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[workplanIndex].simulador.totalPropInicial.toFixed(
                      2
                    )
                  ) + " €"
                }
                position={"start-end"}
                number={"number"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[workplanIndex].simulador.totalValSugerido.toFixed(
                      2
                    )
                  ) + " €"
                }
                position={"middle"}
                number={"number"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={""}
                position={"middle"}
                number={"number"}
                borderless={"borderless"}
              />
            </div>
            <div className="liftworld-table-20-wrapper">
              <TableTextbox
                value={
                  numberWithCommas(
                    workplans[
                      workplanIndex
                    ].simulador.totalValorConsiderar.toFixed(2)
                  ) + " €"
                }
                position={"end"}
                number={"number"}
              />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {finalResult.toFixed(2) < 0 ? (
              <div style={{ color: "#f90d0d" }}>
                {finalResult.toFixed(2) + " € Rever - Valor inferior ao limite"}
              </div>
            ) : finalResult.toFixed(2) > 0 ? (
              <div style={{ color: "#f90d0d" }}>
                {finalResult.toFixed(2) + " € Rever - Valor superior ao limite"}
              </div>
            ) : (
              <div style={{ color: "#048956" }}> {"Valor Ok"}</div>
            )}
          </div>
        </div>
        <div className="liftworld-proposal-main-tables-wrapper">
          <div className="liftworld-proposal-hours-wrapper">
            <div className="liftworld-table-title-wrapper">HORAS</div>
            <ProposalHoursTable
              percentage={
                workplans[workplanIndex].simulador.totalValSugerido /
                workplans[workplanIndex].simulador.totalPropInicial
              }
              newTotalHours={workplans[workplanIndex].simulador.horasOutroValor}
              initialHours={workplans[workplanIndex].simulador.horasPropInicial}
              workplanIndex={workplanIndex}
            />
          </div>
          <div className="liftworld-proposal-hours-wrapper">
            <div className="liftworld-table-title-wrapper">FORNECEDORES</div>
            <ProposalSuppliersTable
              percentage={
                workplans[workplanIndex].simulador.totalValSugerido /
                workplans[workplanIndex].simulador.totalPropInicial
              }
              newTotalSuppliers={
                workplans[workplanIndex].simulador.subcontratosOutroValor
              }
              initialSuppliers={
                workplans[workplanIndex].simulador.subcontratosPropInicial
              }
              workplanIndex={workplanIndex}
            />
          </div>
          <div className="liftworld-proposal-hours-wrapper">
            <div className="liftworld-table-title-wrapper">
              CUSTOS E DESPESAS
            </div>
            <ProposalCostsTable
              percentage={
                workplans[workplanIndex].simulador.totalValSugerido /
                workplans[workplanIndex].simulador.totalPropInicial
              }
              newTotalCosts={
                workplans[workplanIndex].simulador.despesasOutroValor
              }
              initialCosts={
                workplans[workplanIndex].simulador.despesasPropInicial
              }
              workplanIndex={workplanIndex}
            />
          </div>
        </div>
        <ProposalResumeSection
          workplanIndex={workplanIndex}
          percentage={
            workplans[workplanIndex].simulador.totalValSugerido /
            workplans[workplanIndex].simulador.totalPropInicial
          }
          hoursPercentage={
            workplans[workplanIndex].simulador.horasOutroValor /
            workplans[workplanIndex].simulador.horasPropInicial
          }
          suppliersPercentage={
            workplans[workplanIndex].simulador.subcontratosOutroValor /
            workplans[workplanIndex].simulador.subcontratosPropInicial
          }
          costsPercentage={
            workplans[workplanIndex].simulador.despesasOutroValor /
            workplans[workplanIndex].simulador.despesasPropInicial
          }
        />
      </div>
      <div style = {{display : "flex", justifyContent : "flex-start",padding : "30px"}}>
      <SimpleButton
        text={"Imprimir"}
        variant={"liftworld-button-primary"}
        onClick={handlePrint}
      />
      </div>
    </div>
  );
}

export default Simulator;
